import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/BoxButton.css";

const BoxButton = ({
  onNext,
  onPrevious,
  currentStep,
  startAgain,
  viewBoxButton,
  modality,
  urlParamsAml,
}) => {
  const isItalian =
    urlParamsAml === "fisico-eng" || urlParamsAml === "giuridico-eng";

  const texts = {
    back: !isItalian ? "Indietro" : "Back",
    reset: !isItalian ? "Azzera dati" : "Reset data",
    next: !isItalian ? "Avanti" : "Next",
    confirmAml: !isItalian ? "Avanti" : "Next",
    confirmCase: !isItalian ? "Conferma pratica" : "Confirm case",
  };

  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "15px 0px",
        display: "flex",
        justifyContent: { xs: "space-around", sm: "center" },
        alignItems: "center",
      }}
    >
      <Grid container className="container-box-button">
        <Grid item xs={6} md={6}>
          {viewBoxButton === false && currentStep !== 5 ? (
            <Button
              variant="outlined"
              onClick={currentStep === 5 ? startAgain : onPrevious}
              className={`button-bg-light ${currentStep === 1 ? "button-bg-light-disable" : ""}`}
              disabled={currentStep === 1}
              sx={{
                display:
                  currentStep === 1 || currentStep === 6 ? "none" : "flex",
                height: "40px",
                width: { xs: "120px !important", md: "140px !important" },
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                px: "10px",
              }}
            >
              <div
                className="icon-button-prev"
                style={{ position: "absolute", left: "5px", flexShrink: 0 }}
              />
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: 500,
                  lineHeight: 1,
                  whiteSpace: "nowrap",
                }}
              >
                {currentStep === 5 ? texts.reset : texts.back}
              </Typography>
            </Button>
          ) : null}
        </Grid>

        <Grid
          item
          xs={6}
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            className="button-bg-purple"
            onClick={onNext}
            sx={{
              height: "40px",
              width: { xs: "120px !important", md: "140px !important" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              px: "10px",
            }}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 500,
                lineHeight: 1,
                whiteSpace: "nowrap",
              }}
            >
              {modality === "aml" && currentStep === 5
                ? texts.confirmAml
                : currentStep === 5
                  ? texts.confirmCase
                  : texts.next}
            </Typography>
            <div
              className="icon-button-next"
              style={{
                position: "absolute",
                right: "5px",
                flexShrink: 0,
                transform: "rotate(180deg)",
              }}
            />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BoxButton;
